var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('reporte-principal'),_c('div',{staticClass:"reporte-container"},[_c('reporte-sexo'),_c('reporte-peso')],1),_c('div',[_c('reporte-desnutricion'),_c('reporte-vacuna'),_c('reporte-usuario')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }